import { Switch, Route, Redirect } from 'react-router-dom';
import { useUserAuth } from '../state/userAuthContext';
import { dashboardRoutes } from './allRoutes';

const switchRoutes = (
  <Switch>
    {dashboardRoutes.map((prop, key) => {
      if (prop.layout === 'dashboard') {
        return <Route path={`/${prop.layout}${prop.path}`} component={prop.component} key={key} exact />;
      }
      return null;
    })}
    <Redirect from="/dashboard" to="/dashboard/dashboard" />
  </Switch>
);

const Dashboard = () => {
  const { user } = useUserAuth();
  return <> {user && switchRoutes} </>;
};

export default Dashboard;
